const ja = {
    "sc_title": "セキュリティセンター",
    "sc_subtitle": "GaiaShield統合セキュリティレイヤー",
    "sc_tab_status": "🛡️ 保護ステータス",
    "sc_tab_events": "📋 セキュリティログ",
    "sc_tab_node": "⚙️ ノードセキュリティ",
    "sc_loading": "セキュリティデータを読み込み中...",
    "sc_status_secured": "システムステータス: アカウントは保護されています",
    "sc_status_warning": "システムステータス: 警告がアクティブです",
    "sc_desc_secured": "アクティブな重大なセキュリティ警告はありません。GaiaShieldはアカウントをアクティブに監視しています。",
    "sc_desc_warning": "注意: 注意が必要なアクティブなセキュリティイベントがあります。",
    "sc_account_protection": "アカウント保護",
    "sc_message_protection": "メッセージ保護",
    "sc_audits": "セキュリティ監査",
    "sc_active": "アクティブ",
    "sc_failed_logins": "ログイン失敗",
    "sc_tamper_checks": "改ざんチェック",
    "sc_blocked_replays": "ブロックされたリプレイ",
    "sc_last_check": "最終チェック",
    "sc_just_now": "たった今",
    "sc_open_warnings": "未確認の警告",
    "sc_btn_acknowledge": "確認する",
    "sc_filter_severity": "重要度",
    "sc_filter_category": "カテゴリ",
    "sc_filter_hide_ack": "確認済みを非表示",
    "sc_btn_export": "エクスポート",
    "sc_col_details": "詳細",
    "sc_col_time": "時間",
    "sc_col_status": "ステータス",
    "sc_col_action": "アクション",
    "sc_no_events": "セキュリティイベントは見つかりませんでした。",
    "sc_node_title": "ノードオペレーターセキュリティコンソール",
    "sc_system_health": "システムヘルス",
    "sc_last_audit": "最終監査",
    "sc_packed_logs": "アーカイブされたログ",
    "sc_unconfirmed_events": "未確認イベント",
    "sc_operator_action": "オペレーターのアクションが必要です",
    "sc_all_ok": "すべて正常",
    "sc_critical_events": "重大なシステムイベント",
    "ac_title": "ガバナンス＆報告センター",
    "ac_subtitle": "GaiaComガバナンス＆アビューズコンセンサス",
    "ac_tab_my_reports": "マイレポート",
    "ac_tab_queue": "レビュー待ち",
    "ac_tab_operator": "ノードオペレーター",
    "ac_tab_transparency": "フェデレーション＆透明性",
    "ac_loading": "データを読み込み中...",
    "ac_reported_cases": "報告されたケース",
    "ac_no_reports": "報告書はまだ送信されていません。",
    "ac_case_details": "ケース詳細",
    "ac_appeal_submit": "異議申し立てを送信する",
    "ac_appeal_status": "異議申し立てのステータス",
    "ac_appeal_reason": "異議申し立ての理由",
    "ac_appeal_statement": "声明・説明",
    "ac_btn_appeal": "異議申し立てを送信する",
    "ac_trusted_reviewer_queue": "信頼されたレビュー担当者キュー",
    "ac_case_review": "ケースのレビュー",
    "ac_review_category": "推奨カテゴリ",
    "ac_review_severity": "推奨重要度",
    "ac_review_action": "推奨アクション",
    "ac_review_reason": "レビュー担当者の理由",
    "ac_btn_submit_review": "レビューを送信する",
    "ac_node_operator_dashboard": "ノードオペレーターダッシュボード",
    "ac_apply_action": "アクションを適用する (オーバーライド)",
    "ac_target_type": "ターゲットタイプ",
    "ac_target_id": "ターゲットID (GaiaIDまたはチャンネルID)",
    "ac_suspend": "サスペンド有効",
    "ac_reason": "公式の理由",
    "ac_btn_apply": "アクションを強制する",
    "ac_transparency_title": "コンセンサス＆透明性ログブック",
    "ac_transparency_desc": "モデレートされたすべてのチャネルおよびIDの公開可能なスナップショット証明。",
    "ac_btn_snapshot": "透明性スナップショットを作成する",
    "search_placeholder": "件名、送信者、本文でメールを検索...",
    "abuse_center_title": "不正報告センター",
    "abbrechen": "キャンセル",
    "active_identities": "アクティブなアイデンティティ",
    "active_identity": "アクティブなアイデンティティ",
    "add_btn": "追加",
    "add_contact_title": "連絡先を追加",
    "admin": "管理者",
    "adressbuch": "ディレクトリ",
    "aktiviert": "有効",
    "an": "宛先",
    "anonymous_sender": "匿名の送信者",
    "antworten": "答え",
    "attachment_gaia_hint": "GaiaCOM の添付ファイルはエンドツーエンドで暗号化されたままになります。",
    "attachment_smtp_hint": "従来の SMTP は、実行可能ファイルやスクリプトのような添付ファイルをブロックし、電子メールを安全でないものとして保存します。",
    "attachments": "添付ファイル",
    "auffaellig": "不審",
    "auth_beta_notice": "ベータ テスト段階: GaiaCOM は積極的にテストされています。エラーが発生する可能性があります。重要なシードを確保し、機密ワークフローを慎重にレビューします。",
    "auth_btn_login": "ID をロードしてログインする",
    "auth_btn_register": "暗号通貨の登録と作成",
    "auth_copied": "コピーされました",
    "auth_copy_seed": "シードをコピーする",
    "auth_generate_seed": "シードを生成する",
    "auth_headline": "GaiaCOM は、人類のために構築された初の量子安全電子メール プロトコルおよび通信システムです。",
    "auth_kicker": "ポスト量子セキュア通信",
    "auth_mnemonic": "ニーモニックフレーズ",
    "auth_mnemonic_placeholder": "スペースで区切られた 12 個の単語...",
    "auth_password": "パスワード",
    "auth_password_placeholder": "",
    "auth_proof_e2ee_desc": "秘密キーはデバイスから流出しません。意図された受信者のみがコンテンツを復号化できます。",
    "auth_proof_gaiadata_desc": "ゼロ知識: データは自分で管理できます。メタデータは最小化され、プレーン テキスト プロファイルとしては使用されません。",
    "auth_proof_gaiadrop_desc": "外部の人は、アカウントなしであなたの GaiaID に機密テキスト メッセージを送信できます。",
    "auth_proof_gaiaproof_desc": "配信と完全性の証拠は、暗号文、送信者、タイムスタンプが改ざんされていないことを示しています。",
    "auth_proof_gaiavault_desc": "プライベートメモ、リカバリメモ、セキュリティレコードはローカルで暗号化されたままになります。",
    "auth_proof_hybrid_desc": "Quantum Shield: ML-KEM と X25519 を使用したハイブリッド暗号化は、今日の攻撃と、保存して後で復号化するリスクから保護します。",
    "auth_secure_mail": "安全な量子連携メール",
    "auth_subline": "GaiaCOM は、電子メール、チャット、危機管理室、GaiaDrop、ローカル セキュリティ ファイル用の量子安全通信システムです。秘密キーはデバイス上に残り、コンテンツはエンドツーエンドで暗号化され、証拠は平文なしでエクスポートできます。",
    "auth_success_btn": "今すぐログインしてください",
    "auth_success_text": "GaiaCOM アカウントが作成されました。キーはシードからローカルに派生され、サーバーには保存されませんでした。",
    "auth_success_title": "登録が成功しました",
    "auth_tab_drop": "ガイアドロップ",
    "auth_tab_login": "ログイン/アカウント",
    "auth_toggle_login": "アカウントはすでに存在します",
    "auth_toggle_register": "新しいアカウントを作成する",
    "auth_usecase_text": "弁護士、企業、当局、ジャーナリスト、内部告発者、個人のセキュリティ事件に適しています。",
    "auth_usecase_title": "機密性の高いコミュニケーションのために構築",
    "auth_username": "ユーザー名",
    "auth_username_placeholder": "名前を入力してください...",
    "auth_value_chat": "E2E チャット",
    "auth_value_drop": "セキュアドロップ",
    "auth_value_mail": "安全なメール",
    "auth_value_rooms": "ガイアルームズ",
    "bestaetigen": "確認する",
    "bestaetigt": "確認済み",
    "bio_status": "略歴・地位",
    "biography": "バイオグラフィー",
    "change_password_desc": "サーバー側のログインパスワードを変更します。ローカルの回復フレーズは、保管庫/ロック解除パスワードによって個別に保護されたままになります。",
    "change_password_menu_desc": "GaiaCOM ログイン パスワードを更新します。",
    "change_password_title": "パスワードを変更する",
    "channel_id": "チャンネルID",
    "channel_name_label": "チャンネル名",
    "chat_deleted_hidden": "チャットが削除され、非表示になりました。",
    "chat_input_placeholder": "安全なメッセージを入力してください...",
    "chat_start_hint": "会話を始めましょう！すべてのチャット メッセージは量子セキュア E2E 暗号化されています。",
    "choose_avatar": "アバターを選択してください",
    "ciphertext_hash": "暗号文ハッシュ",
    "clear_chat": "空のチャット",
    "clear_for_everyone": "誰にとっても空です",
    "clear_for_me": "私だけのための空",
    "click_to_write_mail": "クリックしてメールを書く",
    "click_top_right": "右上をクリックしてください",
    "close": "近い",
    "code_kopieren": "コードをコピーする",
    "code_kopieren_success": "コードをコピーしました",
    "confirm_clear_channel_desc": "このチャンネルをローカルビューから消去しますか?",
    "confirm_clear_channel_title": "空のチャンネル",
    "confirm_clear_chat": "このチャットを空にしますか?",
    "confirm_clear_chat_desc": "このチャットを空にしますか?",
    "confirm_clear_chat_title": "空のチャット",
    "confirm_clear_everyone": "両方のパートナーのチャットを空にしますか? (OK = 全員、キャンセル = 私だけ)",
    "confirm_delete_everyone": "両方のパートナーへのメッセージを削除しますか? (OK = 全員、キャンセル = 私だけ)",
    "confirm_delete_msg": "このメッセージを削除しますか?",
    "confirm_delete_msg_desc": "このチャット メッセージを削除しますか?",
    "confirm_delete_msg_title": "メッセージを削除する",
    "confirm_new_password": "新しいパスワードを確認します",
    "copy": "コピー",
    "create_btn": "作成する",
    "create_channel_title": "チャンネルの作成",
    "create_group_is_crisis": "危機地域としてマークする",
    "create_group_title": "新しいグループを作成する",
    "crypto_lock_desc": "GaiaCOM がメモリからローカル暗号キーを削除するタイミングを制御します。",
    "crypto_lock_menu_desc": "リロードタイマーと非アクティブタイマーを制御します。",
    "crypto_lock_title": "暗号ロック",
    "crypto_session_duration": "リロード後にロック解除される",
    "crypto_session_duration_desc": "選択した期間だけ、このブラウザ タブで暗号化セッションを開いたままにします。",
    "cryptographic_fingerprint": "暗号化指紋",
    "current_password": "現在のパスワード",
    "data_minimization": "データ最小化",
    "decrypt_failed": "解読不能",
    "delete": "消去",
    "delete_account_button": "アカウントを取り消し不能に削除する",
    "delete_account_confirm_label": "「DELETE」と入力して確認します",
    "delete_account_confirmation_error": "パスワードと削除の確認が必要です。",
    "delete_account_desc": "このモードでは、アカウント、ID、デバイス セッション、GaiaDrop データ、アップロード メタデータ、およびサーバー側に起因するメッセージが永久に破壊されます。",
    "delete_account_done_desc": "割り当て可能なすべての GaiaCOM データが削除されました。",
    "delete_account_done_title": "アカウントが削除されました",
    "delete_account_menu_desc": "アカウントと関連データを破棄します。",
    "delete_account_not_authenticated": "アクティブなアカウントはありません。",
    "delete_account_title": "アカウントを削除する",
    "delete_for_everyone": "全員に削除",
    "delete_for_me": "私だけに削除してください",
    "device_current": "このデバイス",
    "device_last_seen": "最後",
    "device_logout": "ログアウト",
    "device_sessions_desc": "アクティブなセッションを確認し、信頼できなくなったデバイスの登録を解除します。",
    "device_sessions_empty": "デバイスが見つかりませんでした。",
    "device_sessions_menu_desc": "アクティブなセッションを管理および終了します。",
    "device_sessions_title": "登録済みのデバイス",
    "device_since": "以来",
    "display_name": "表示名",
    "drop_address_copied": "GaiaDrop アドレスがコピーされました。",
    "drop_btn_decrypting": "受信トレイを復号化しています...",
    "drop_btn_load": "GaiaDrop 受信箱をロードする",
    "drop_delete_desc": "このドロップを完全に削除してもよろしいですか?",
    "drop_delete_title": "GaiaDropを削除する",
    "drop_desc": "外部通知、責任ある開示、機密報告のためのテキストのみのゼロ知識ドロップ チャネル。外部の関係者は、GaiaID を使用してアカウントなしでメッセージを送信できます。",
    "drop_empty": "GaiaDrop メッセージはまだロードされていません。",
    "drop_id": "ドロップID:",
    "drop_own_address": "GaiaDrop アドレス",
    "drop_proof": "DROP PROOF",
    "drop_title": "GaiaDrop 安全な受信箱",
    "dunkler_modus": "ダークモード",
    "e2e_chat_room_open": "E2E チャット ルームを開く",
    "edit_profile": "プロフィールの編集",
    "edit_profile_desc": "表示名、プロフィール、アバターをカスタマイズします。",
    "einladungscode": "招待コード",
    "enter_fingerprint_chars_confirm": "要求された指紋文字を入力して確認します。",
    "envelope_hash": "エンベロープハッシュ",
    "erasability": "消去可能性",
    "erfolg": "成功",
    "exclude_plaintext": "プレーンテキストなしでエクスポート",
    "export_disclosure": "セキュリティケースのエクスポート",
    "export_package_desc": "この開示が意図されている場合は、プレーン テキストのみを含めてください。",
    "export_package_title": "セキュリティパッケージのエクスポート",
    "fehler": "間違い",
    "gaiacom_reader": "GaiaCOMリーダー",
    "gaiadrop_inbox_title": "GaiaDropインボックス",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM はメタデータを最小限に抑え、秘密キーをローカルに保持し、コンテンツをエンドツーエンドで暗号化し、アカウントの完全な削除を可能にします。",
    "gdpr_home_title": "100% GDPR 準拠",
    "gdpr_reason_delete": "アカウントを削除すると、アカウント、ID、ローカル セッション、およびサーバー側で割り当て可能なデータが削除されます。",
    "gdpr_reason_e2ee": "プライベート コンテンツは、意図された受信者のみが復号化できます。",
    "gdpr_reason_minimal": "メタデータは、ルーティング、配信、およびセキュリティ認証情報にのみ使用されます。",
    "gdpr_reason_zero_knowledge": "秘密キーと回復データはローカルでユーザーの管理下に残ります。",
    "gesendet": "送信済み",
    "gesperrt_verdaechtig": "ブロック中 / 不審",
    "group_delete_desc": "このグループを完全に削除してもよろしいですか?このグループ内のすべてのチャンネルとメッセージが削除されます。",
    "group_delete_title": "グループの削除",
    "group_description": "説明",
    "group_icon_label": "グループアイコン/アバター",
    "group_name": "グループ名",
    "group_settings_avatar": "アバター",
    "group_settings_desc": "説明",
    "group_settings_is_crisis": "危機地域としてマークする",
    "group_settings_name": "グループ名",
    "group_settings_title": "グループ設定",
    "groups_empty_desc": "プロジェクト、危機、チームのコミュニケーションのための安全なワークスペースを作成します。",
    "groups_empty_title": "グループチャットはまだありません",
    "gruppe_beitreten": "参加したグループ",
    "gruppe_erstellen": "+ グループの作成",
    "gruppe_verlassen": "グループを離れる",
    "gruppen_chats": "グループチャット",
    "heller_modus": "ブライトモード",
    "how_to_receive_drops": "ドロップの受信方法は？",
    "identitaets_assistent": "ID アシスタント",
    "inactivity_lock_duration": "非アクティブ時にロックする",
    "inactivity_lock_duration_desc": "この期間入力がない場合、GaiaCOM は自動的に暗号的にロックされます。",
    "inactivity_lock_notice": "GaiaCOM は、非アクティブのため暗号的にブロックされました。",
    "include_plaintext": "プレーンテキストを含める",
    "invite_code_label": "招待コード",
    "join_group_title": "グループに参加する",
    "kanaele": "チャンネル",
    "kanal_erstellen": "+チャンネル",
    "kein_chat_ausgewaehlt": "チャットが選択されていません",
    "kein_kanal_ausgewaehlt": "チャンネルが選択されていません",
    "keine_gruppe_ausgewaehlt": "グループが選択されていません",
    "keine_mails": "利用できる電子メールはありません。",
    "key_change_warn_desc": "この連絡先の公開キーが変更されました。指紋を信頼する前に確認してください。",
    "key_change_warn_title": "暗号化に関する警告",
    "key_change_warning_changed": "変わりました。これは中間者攻撃の兆候である可能性があります。",
    "key_change_warning_msg": "連絡先の公開鍵",
    "key_transparency": "鍵の透明性（鍵履歴）",
    "kopiert": "コピーされました",
    "kryptographische_schluessel": "暗号キー",
    "kryptographische_schluessel_desc": "秘密キーとバックアップ シード フレーズを表示します。",
    "laden": "負荷...",
    "leeren": "空の",
    "loading": "負荷...",
    "local_key_vault": "ローカルキーコンテナー",
    "local_keys_label": "ローカルキー",
    "lock_on_reload": "リロード後は必ずロックする",
    "logout": "ログアウト",
    "mail_compose": "メールを書く",
    "mein_profil": "私のプロフィール",
    "melden": "報告",
    "menu": "メニュー",
    "message": "ニュース",
    "message_id": "メッセージID",
    "message_pin": "ピン",
    "message_pinned_title": "固定メッセージ",
    "message_react": "反応する",
    "message_reply": "答え",
    "message_replying_to": "への回答",
    "message_save": "保存",
    "message_saved": "保存されました",
    "message_to_channel": "へのメッセージ",
    "message_unpin": "解決する",
    "message_unsave": "保存しないでください",
    "mitglied": "メンバー",
    "mitglieder": "メンバー",
    "ml_kem": "ML-KEM",
    "neue_mail": "新しいメール",
    "never_auto_lock": "決して自動的には行わない",
    "new_fingerprint": "新しい指紋",
    "new_identity": "新しいアイデンティティ",
    "new_password": "新しいパスワード",
    "no_description": "説明なし",
    "no_key_history": "鍵の履歴は記録されていません。",
    "no_specification": "指定されていない",
    "old_fingerprint": "古い指紋",
    "open_privacy_imprint": "オープンインプリントとデータ保護",
    "post_quantum_e2e": "ポスト量子 E2E",
    "posteingang": "受信箱",
    "powered_by": "Powered by",
    "privacy_imprint_menu_desc": "GDPR、データ保護、法的通知を表示します。",
    "privacy_imprint_profile_desc": "GaiaCOM は、データの最小化、エンドツーエンドの暗号化、およびローカル鍵制御の原則に従って通信コンテンツを処理します。",
    "privacy_imprint_title": "データ保護と法的通知",
    "profil": "プロフィール",
    "profile_details": "プロフィールの詳細",
    "profile_settings_hint": "プロファイル設定が右側のパネルに表示されます。",
    "profile_unlock_desc": "セキュリティ上の理由から、秘密暗号キーを表示するにはパスワードを再入力する必要があります。",
    "proof_hash": "証明ハッシュ:",
    "public_drop_desc": "GaiaCOM アカウントを持たない外部テキスト情報の Secure Drop。",
    "public_drop_message": "ニュース",
    "public_drop_message_placeholder": "機密テキストを入力してください...",
    "public_drop_send": "ガイアドロップを送信する",
    "public_drop_sender": "送信者のメモはオプションです",
    "public_drop_sender_placeholder": "名前、ファイル番号、または匿名",
    "public_drop_target": "対象のGaiaID",
    "quanten_chat": "量子チャット",
    "quantum_secure_exchange": "...を介した量子安全交換",
    "quantum_secure_net": "GaiaCOM 量子セキュア ネットワーク (Ed25519 & ML-KEM)",
    "quantum_shield_desc": "GaiaCOM ネットワークは、将来の量子コンピューターからの攻撃から保護される多層ハイブリッド暗号化プロトコルを使用してプライバシーを保護します。",
    "quantum_shield_l1_desc": "FIPS 203 標準を使用して対称共有キーをカプセル化します。量子コンピューターによる受動的記録とその後の復号化 (「今保存し、後で復号化」) を防止します。",
    "quantum_shield_l1_title": "1.量子後保護 (ML-KEM-1024)",
    "quantum_shield_l2_desc": "古典的な非常に高速な Diffie-Hellman 鍵交換手順。ハイブリッド手順における追加のセキュリティ層として機能します。",
    "quantum_shield_l2_title": "2. 楕円曲線暗号 (X25519)",
    "quantum_shield_l3_desc": "すべてのメッセージとすべてのフェデレーション エンベロープは、送信者の信頼性を明確に検証するために暗号的に署名されます。",
    "quantum_shield_l3_title": "3. デジタル署名 (Ed25519)",
    "quantum_shield_l4_desc": "メッセージ コンテンツを対称的に暗号化し、送信者、受信者、メタデータを認証済み追加データ (AAD) に緊密にバインドして、リプレイ攻撃を防ぎます。",
    "quantum_shield_l4_title": "4.AAD認証(AES-256-GCM)",
    "quantum_shield_status": "クオンタムシールドのステータス",
    "receive_drops_step1": "あなたのGaiaIDを外部ソースと共有します（例：上記のコピーボタン）。",
    "receive_drops_step2": "彼らはあなたのGaiaCOMインスタンスのログインページを開き、タブを切り替えます",
    "receive_drops_step3": "そしてそこで暗号化されたメッセージをあなたの住所に送信します。",
    "receiver_gaia": "GaiaCOM受信機",
    "receiver_smtp": "SMTP受信者",
    "records_stored": "保存された記録",
    "refresh": "アップデート",
    "report_abuse_desc": "このメッセージを報告し、悪用の暗号証拠をサーバーに送信しますか?",
    "report_abuse_title": "不正行為を報告する",
    "reputation_status": "レピュテーションステータス",
    "room_chat_start_hint": "会話を始めましょう！このグループ チャネル内のすべてのメッセージは、分散型量子安全な E2E 暗号化されています。",
    "room_policy_audit": "監査証跡とキーローテーションがアクティブです。",
    "room_policy_crisis": "危機管理室",
    "room_policy_e2ee": "ゼロ知識空間。 E2EE 量子安全。",
    "room_policy_title": "部屋のガイドライン",
    "room_policy_zero_knowledge": "ポリシー",
    "room_security_note_desc": "すべてのキーの変更は、Key Transparency によって検証されます。プライベート バックアップ ログには GaiaVault を使用します。",
    "room_security_note_title": "固定されたセキュリティメモ",
    "save_profile": "プロファイルの保存",
    "schluessel_entsperrt": "🔑 再度キーをロックします",
    "search_gaia_label": "ガイアのアドレスを探す",
    "security_warning_title": "セキュリティ警告",
    "select_channel_chat": "左側のサイドバーからチャンネルを選択してチャットします。",
    "select_contact_chat": "左側のパネルから連絡先を選択して、量子安全な E2E チャットを開始します。",
    "select_mail_read": "リストから電子メールを選択して、その量子安全なコンテンツを読むか、新しいメッセージを作成します。",
    "senden": "送信",
    "sender_signature": "送信者署名",
    "server_log": "サーバーログ:",
    "server_received": "サーバー受信日時",
    "session_lock": "セッションロック",
    "setup_address_keys": "アドレスとキーセットの作成",
    "setup_profile": "プロフィールで設定する",
    "smtp_inbox_title": "SMTP受信",
    "smtp_legacy_badge": "レガシー SMTP / 安全ではない",
    "smtp_mode_option": "レガシー SMTP ブリッジ",
    "smtp_security_warning": "この電子メールは、従来の暗号化されていない SMTP プロトコルを介して送信されました。有効なエンドツーエンド暗号化はありません。",
    "smtp_security_warning_desc": "このメッセージは GaiaCom セキュリティ ルームから出ています。 SMTP 配信では、GaiaCom ネイティブのエンドツーエンド保証、TrustMesh 保証、ゲートウェイからの Godmode 保証は提供されません。",
    "spam_verdacht": "スパム/疑惑",
    "spam_warning_desc": "このメッセージには疑わしい評判シグナルが含まれています。",
    "spam_warning_title": "スパム警告",
    "speichern": "保存",
    "sperren": "ロックアウト",
    "standard_group_status": "標準グループチャット（E2EE暗号化）",
    "status": "状態",
    "subject": "に関して",
    "suchen": "新しい Gaia アドレスを見つけてください...",
    "tage": "日",
    "time_unknown": "時間不明",
    "transmission_mode": "転送モード",
    "trust_age": "信頼期間",
    "trust_passport_title": "トラストパスポート",
    "unbestaetigt": "未確認",
    "unknown_sender": "未知",
    "unlock_btn": "ロックを解除する",
    "unlock_btn_profile": "ロックを解除する",
    "unlock_desc": "秘密キー ファイルは暗号化されて保存されます。パスワードを入力すると、暗号化キーがメモリのみにロードされます。",
    "unlock_logout": "ログアウトしてローカルキーを閉じる",
    "unlock_title": "アイデンティティのロックを解除する",
    "untrusted": "非信頼",
    "update_password": "パスワードを更新する",
    "upload_avatar_btn": "画像をアップロード（サニタイズ済み）",
    "vault_btn_encrypt": "レコードの暗号化",
    "vault_btn_lock": "金庫をロックする",
    "vault_btn_unlock": "金庫のロックを解除する",
    "vault_copied_success": "クリップボードにコピーされました",
    "vault_decrypted_content": "復号化されたコンテンツ",
    "vault_desc": "リカバリ バックアップ、ID メモ、サーバー アクセス、緊急連絡先、法的メモ、セキュリティ イベント、プライベート ログ用のローカル暗号化保管庫。",
    "vault_empty": "安全な記録はまだ保存されていません。",
    "vault_locked_pane_notice": "保管庫はロックされています。右側でロックを解除してください。",
    "vault_new_record": "新しい安全な記録",
    "vault_pwd_placeholder": "ボールトのパスワードを入力してください...",
    "vault_record_body": "記録内容",
    "vault_record_body_placeholder": "暗号化されたレコードの内容を入力してください...",
    "vault_record_category": "カテゴリ",
    "vault_record_title": "レコードタイトル",
    "vault_record_title_placeholder": "セキュアレコードのタイトル",
    "vault_title": "GaiaVault の安全な記録",
    "verify_new_fingerprint_hint": "キーを受け入れる前に、新しい指紋を確認してください。",
    "vertrauenswuerdig": "信頼できる",
    "vision_gaia_technology": "VisionGaiaTechnology",
    "von": "から",
    "warnung": "警告",
    "wizard_address": "住所",
    "wizard_back": "戻る",
    "wizard_check1": "無事に種を保存できました。",
    "wizard_custom_domain": "独自のドメインを使用する",
    "wizard_desc1": "GaiaCOM はサーバー側に秘密鍵を保管しません。ニーモニック シードがなければ、失われたメッセージを回復することはできません。",
    "wizard_desc2": "アドレスによって、暗号化されたエンベロープがルーティングされるフェデレーテッド ノードが決まります。",
    "wizard_fallback": "フォールバックノード",
    "wizard_finish": "セットアップを完了する",
    "wizard_next": "さらに遠く",
    "wizard_server_domain": "サーバーノードドメイン",
    "wizard_step1": "1. バックアップシード",
    "wizard_step2": "2. アドレスとサーバー",
    "wizard_title1": "バックアップ回復キー",
    "wizard_title2": "GaiaCOM アドレスを選択してください",
    "write_message_placeholder": "安全なメッセージを書いてください...",
    "you": "あなた",
    "zero_knowledge": "ゼロ知識",
    "zero_knowledge_encryption": "ゼロ知識暗号化",
    "Chat fuer alle geleert": "チャットはすべての参加者に対して空になりました。",
    "Chat geleert": "チャットはローカルの受信トレイから消去されました。",
    "Nachricht fuer alle geloescht": "メッセージは参加者全員に対して削除されました。",
    "Nachricht geloescht": "チャット メッセージは受信トレイからローカルに削除されました。",
    "anpinnen": "ピン",
    "chat_loeschen": "チャットを削除する",
    "confirm_delete_chat_desc": "チャットを削除して非表示にしてもよろしいですか?",
    "confirm_leave_group_desc": "本当にこのグループを離れたいですか?",
    "entpinnen": "固定を解除する",
    "group_deleted": "グループは正常に削除されました。",
    "group_left": "グループから正常に脱退しました。",
    "gruppe_loeschen": "グループの削除",
    "loeschen": "消去",
    "no_active_chats": "アクティブなチャットはありません。チャットを開始するには、上で連絡先を検索してください。",
    "pinned": "固定された",
    "wizard_check_credentials": "私にはアクセスデータを安全に保つ責任があります。",
    "wizard_check_is_beta": "GaiaCom はベータ版ソフトウェアであることを理解しています。",
    "wizard_check_no_illegal": "私は GaiaCom を違法な目的で使用しません。",
    "wizard_check_no_uptime": "利用可能であるという保証はないことを理解しています。",
    "wizard_check_smtp_security": "SMTP メッセージでは完全な GaiaCom セキュリティが提供されないことを理解しています。",
    "wizard_check_terms_read": "ベータ版の利用規約を読みました。",
    "wizard_step_terms": "利用規約",
    "wizard_terms_text": "GaiaCom の利用規約とベータ テスト契約 (ベータ段階)\n\n提供者：VisionGaiaTechnology（以下「提供者」といいます）\nステータス: パブリックベータテスト段階\n有効期限：2026年6月21日から\n\n⚠️事前に最も重要な注意事項（よくお読みください）\nGaiaCom はパブリック ベータ テスト段階にあります。広範なセキュリティ対策が講じられているにもかかわらず、エラーがないこと、ソフトウェアと基盤となるインフラストラクチャの継続的な可用性、または絶対的なセキュリティを保証することはできません。ご自身の責任でご使用ください。ユーザーは、アクセス データ (特に GaiaVault のキー) を安全に保管し、適用される法律を遵守する責任があります。\n\n1. ベータテストフェーズの主題と目的\n1.1.提供目的：GaiaComはポスト量子暗号（PQC）をベースとした斬新なメール・チャットサービスです。ベータ段階での提供は、技術テスト、負荷シミュレーション、プログラム エラー (バグ) の発見、およびユーザー フレンドリーの最適化のみを目的としています。\n1.2.ベータ ステータス: ユーザーは、提供されているソフトウェアが暫定バージョン (ベータ ソフトウェア) であることを認識しています。これは技術的にまだ完全に開発されておらず、最終的な商用製品の基準を満たしておらず、エラー、データ損失、伝送遅延、システムクラッシュを引き起こす可能性があります。\n1.3.継続権なし: プロバイダーはいつでも、理由を提示することなく、サービスの全部または一部を中止したり、機能を変更または制限したり、一時的または永久に削除したりする権利を有します。\n\n2. 保証の利用可能性と免責事項\n2.1.可用性の保証なし: GaiaCom は、可用性または稼働時間の保証なしで提供されます。サービスを中断なく利用できる権利はありません。\n2.2.保証の除外: ソフトウェアは現在の状態 (「現状のまま」) で提供され、入手可能な場合に限ります。法律で認められる範囲で、ソフトウェアの重大な法的欠陥に対する保証請求は除外されます。特に、ソフトウェアにエラーがないこと、マルウェアがないこと、または特定の目的に適していることは保証されません。\n\n3. リスク管理とユーザーの義務\n3.1.重要なデータの保管の禁止: ユーザーは、ビジネス上重要なデータ、重要なデータ、運用上必要なデータ、または法的に特に機密性の高いデータ (患者ファイル、非常に機密性の高い財務データ、公的に規制されている秘密など) を独占的に保管したり、GaiaCom 経由で送信したりしないことを約束します。このサービスは、予期せぬ障害が人身傷害、物的損害、または重大な経済的損失を引き起こす可能性があるインフラストラクチャには使用できません。\n3.2.自己責任のバックアップ: ユーザーは、長期的に必要となる GaiaCom 経由で送受信されるすべてのデータを、自分の独立したシステムにバックアップする責任があります (バックアップ コピー)。プロバイダーは、サーバー上のデータの永続的な保存や復元可能性を保証しません。\n\n4. 暗号化機能と GaiaVault\n4.1.ポスト量子暗号 (PQC): GaiaCom は、将来の量子コンピューターからの攻撃に耐えるように設計された、最先端の未来志向の暗号化プロセスを実装しています。ただし、ユーザーは、これが動的で新しい科学分野であることを認識しています。現在の科学技術の現状では、絶対的、反駁の余地のない安全性は保証されません。 「100% 安全」、「解読不可能」、または「軍事的安全」などの用語は明示的に保証されていません。\n4.2.回復保証なし (GaiaVault): GaiaCom は、一貫したゼロ知識セキュリティ概念に依存しています。暗号化ウェッジとアクセス データは、ユーザーのみが管理できます (GaiaVault 経由で保護されています)。\n重要: ユーザーがパスワード、パスフレーズ、秘密キー、または回復シードを紛失した場合、プロバイダーにはこのデータを再構築またはリセットする技術的能力がありません。これらのアクセス データが失われると、必然的にユーザー アカウントとその中で暗号化されているすべてのデータへのアクセスが取り消せなくなります。\n4.3.まだ完全に監査されていない: ソフトウェアは継続的に内部セキュリティ チェックを受けていますが、このベータ段階の時点では、独立したテスト機関による最終的な包括的な外部セキュリティ監査はまだ受けていません。\n\n5. インターフェース、レガシープロトコル、フェデレーション\n5.1. SMTP ブリッジ 注: GaiaCom は、従来の電子メール プロトコル (SMTP など) を介して通信する機能を提供します。ユーザーは、ネイティブの GaiaCom セキュリティ領域を離れるメッセージ (従来の @gmail.com または @gmx.de アドレスに送信される場合など) が、暗号化されていないサーバーまたはサードパーティのサーバーを介して転送されることを認識しています。 GaiaCom のエンドツーエンドのセキュリティ保証は、そのような送信または外部から受信するレガシー メッセージには、限られた範囲でのみ適用されるか、まったく適用されません。\n5.2.フェデレーションに関する注意: GaiaCom がフェデレーション ネットワーク上で動作している場合、メッセージとデータはサードパーティのサーバーを通過する可能性があります。メッセージの内容はエンドツーエンドの暗号化によって保護されたままですが、メタデータ (送信時刻、関係するサーバーの IP アドレス、受信者のアドレスなど) は、技術的にはこれらのフェデレーション サーバーのオペレーターに見える可能性があります。プロバイダーは、フェデレーション ネットワーク内のサードパーティ サーバー オペレーターのデータ保護慣行に影響を与えません。\n\n6. 許容される使用と禁止される行為\nユーザーは、サービスを不正または違法な目的で使用しないことを約束します。特に、以下のことは禁止されています。\n- ウイルス、マルウェア、フィッシング コンテンツ、またはその他の悪意のあるソフトウェアを配布、送信、またはホストすること。\n- サービス拒否攻撃 (DDoS) または迷惑な大量メール (スパム) を実行するために本サービスを使用する。\n- システムを悪用して詐欺を行うこと。\n- 違法なコンテンツ、特に児童性的虐待 (CSAM) の描写、テロリストのプロパガンダ、暴力またはその他の犯罪に関連するコンテンツの配布または交換。\n\n7. 不正行為報告制度\n7.1.不正行為の報告: ユーザーには、統合された不正行為システムを介して不正な通信や違法行為を報告する機会があります。\n7.2.レポートの処理: 悪用から確実に保護するために、(プライバシーと暗号化の制限を維持しながら) 受信レポートを技術的に分析できます。これらの利用規約への違反が判明した場合、ユーザー アカウントまたは IP アドレスが一時的または永久に停止される可能性があります。\n\n8. 責任の制限\n8.1.責任基準: ベータ版ソフトウェアは無料で提供されます。したがって、寄付や融資に関する法的規則によれば、提供者は故意（故意の損害）と重過失に対してのみ責任を負います。\n8.2.データ損失に対する責任の除外: データ損失に対する責任は、損失がプロバイダーの故意または重大な過失によって生じたものであり、ユーザーが定期的なバックアップ (GaiaCom 外部) を通じて損害を軽減する義務を履行していない限り、除外されます。\n8.3.法的制限: 上記の責任制限は、生命、身体、健康に対する損害、または製造物責任法に基づく責任には適用されません。\n\n9. オープンソース\n特定の GaiaCom コンポーネント、ライブラリ、またはクライアント アプリケーションは、オープン ソース ライセンス (GPL、MIT、Apache など) に基づいてライセンス供与される場合があります。これらのコンポーネントのそれぞれのライセンス条項は、これらの使用条件の影響を受けず、対応するソース コード リポジトリで参照できます。\n\n10. 輸出管理とコンプライアンス\nユーザーは、暗号化ソフトウェアが厳格な輸出規制および法的制限の対象となる可能性があることを認識しています。ユーザーは、GaiaCom の使用がそれぞれの居住国の法律、輸出入制限、または暗号化規制に違反しないことを確認する責任があります。\n\n11. データ保護に関する通知 (ベータ版の短縮版)\n11.1.最小限のデータ収集: ベータ段階の一環として、プロバイダーは技術的な運用、トラブルシューティング、さらなる開発に絶対に必要なデータのみを収集します (例: エラー診断用のサーバー ログ ファイル)。\n11.2.コンテンツに対する洞察がありません: 一貫したゼロ知識と E2E 暗号化のおかげで、プロバイダーはチャット、電子メール、または GaiaVault に保存されているキーのコンテンツにアクセスすることはありません。\n11.3.詳細なデータ保護宣言: 詳細なデータ保護規則は個別にリンクされており、ユーザーは登録する前にこれも考慮する必要があります。\n\n12. 最終条項\n12.1.適用法: 国際物品売買契約に関する国連条約を除き、ドイツ連邦共和国の法律が適用されます。\n12.2.変更される可能性があります: GaiaCom は現在開発中であるため、プロバイダーは将来にわたってこれらの条件をいつでも適応させる権利を留保します。現在のバージョンはアプリケーションで利用できます。",
    "wizard_terms_title": "GaiaCom の利用規約とベータ テスト契約 (ベータ段階)",
    "node_operator": "ノードオペレーター",
    "search_channels": "チャンネルを検索...",
    "senior_reviewer": "上級査読者",
    "trusted_reviewer": "信頼できるレビュアー",
    "active_frequencies": "アクティブ周波数",
    "connected_rooms": "つながった空間",
    "dashboard": "ダッシュボード",
    "empty_chats": "利用可能なアクティブなチャットはありません。",
    "empty_messages": "新しいメッセージはありません。",
    "encrypted": "暗号化された",
    "gaiacom_uplink": "ガイアコムアップリンク",
    "install_app": "アプリをインストールする",
    "install_app_desc": "クイックスタートとオフラインモードの場合",
    "kommandozentrale_alpha": "ALPHAコマンドセンター",
    "network_online": "ネットワーク: オンライン",
    "new_room": "新しい空間",
    "no_frequencies_active": "アクティブな周波数はありません。新しいルームを作成してコミュニケーションを開始します。",
    "no_id": "身分証明書なし",
    "open_chats": "オープンチャット",
    "open_inbox": "受信箱を開く",
    "primary_identity": "主要なアイデンティティ",
    "recent_chats": "新しいチャット",
    "recent_messages": "最新ニュース",
    "session_encrypted": "セッションが暗号化されました: {name}",
    "session_secure": "ステータス: 安全",
    "system_verlassen": "出口システム",
    "write_message": "メッセージを書く",
    "onboarding_step_profile": "プロフィール",
    "onboarding_step_security": "保護",
    "onboarding_step_backup": "バックアップ",
    "onboarding_step_launch": "スタート",
    "onboarding_loading_gaia_id": "Gaia-IDを読み込み中",
    "onboarding_setup_kicker": "GaiaComの初期セットアップ",
    "onboarding_profile_title": "GaiaComをあなたの空間に。",
    "onboarding_profile_desc": "表示名とアバターはローカルで管理され、後でいつでもプロフィールで変更できます。",
    "onboarding_security_title": "GaiaComがあなたのために保護しているもの。",
    "onboarding_security_desc": "GaiaComは、ID、キー、メッセージ、およびネットワークステータスを分離します。ここでは、簡単なユーザー向け説明のみを表示しています。",
    "onboarding_backup_title": "バックアップは真の非常口です。",
    "onboarding_backup_desc": "復元データがないと、誰もあなたのIDを救うことができません。これこそが真のエンドツーエンドのセキュリティのポイントです。",
    "onboarding_launch_title": "準備完了。まず何をしますか？",
    "onboarding_launch_desc": "すぐに始めることも、ツアーを終了してダッシュボードで作業を続けることもできます。",
    "onboarding_display_name": "表示名",
    "onboarding_display_name_placeholder": "どのように表示しますか？",
    "onboarding_select_avatar": "アバターを選択",
    "onboarding_sec_identity_title": "アイデンティティ",
    "onboarding_sec_identity_desc": "あなたのGaia-IDはネットワークのアンカーです。連絡先はキーの交換を検出できます。",
    "onboarding_sec_messages_title": "メッセージ",
    "onboarding_sec_messages_desc": "コンテンツはローカルで復号されます。編集されたメッセージは新しい署名を受信します。",
    "onboarding_sec_network_title": "ネットワーク",
    "onboarding_sec_network_desc": "セキュリティセンターと違反報告センターは、グローバルなバックドアなしでリスクを可視化します。",
    "onboarding_sec_transparency_title": "透明性",
    "onboarding_sec_transparency_desc": "セキュリティ関連のイベントをログに記録し、警告の追跡可能性を維持します。",
    "onboarding_backup_notice_title": "一般ユーザーへの重要事項",
    "onboarding_backup_notice_desc": "復元データはこのデバイスとは別に保存してください。パスワードとバックアップを紛失した場合、GaiaComは意図的にロックされたままになります。",
    "onboarding_backup_consent": "バックアップが復元とデバイス変更に不可欠であることを理解しています。",
    "onboarding_inbox_title": "受信トレイ",
    "onboarding_inbox_desc": "メールを読んで最初のメッセージを作成する。",
    "onboarding_contacts_title": "連絡先",
    "onboarding_contacts_desc": "最初の連絡先を確認するか、チャットを開始する。",
    "onboarding_channels_title": "チャンネル",
    "onboarding_channels_desc": "パブリック周波数を発見する。",
    "onboarding_security_title_card": "セキュリティセンター",
    "onboarding_security_desc_card": "GaiaShieldのステータスを表示。",
    "onboarding_later": "後で",
    "onboarding_back": "戻る",
    "onboarding_continue": "進む",
    "onboarding_complete_setup": "セットアップを完了",
    "auth_legal_consent": "プライバシーポリシーと利用規約を読み、これに同意します。",
    "auth_show_terms": "利用規約を表示",
    "auth_recovery_mode": "リカバリーモード",
    "auth_recovery_import_title": "リカバリーファイルのインポート",
    "auth_recovery_import_desc": "パスワードで保護されたバックアップファイルから GaiaCom キーを復元します。復元後、ニーモニックとユーザー名が事前に入力されます。",
    "auth_recovery_file_pwd_placeholder": "リカバリーファイルのパスワード",
    "auth_recovery_local_pwd_placeholder": "新しいローカルロック解除パスワード（最低12文字）",
    "auth_recovery_importing": "インポート中...",
    "auth_recovery_decrypt": "リカバリーの復号",
    "auth_back_to_login": "ログインに戻る",
    "auth_terms_title": "GaiaComベータ版利用規約",
    "auth_terms_close": "閉じる",
    "auth_cookie_title": "GaiaCOMは主権を維持します。",
    "auth_cookie_desc": "言語、セッション、セキュリティのために技術的に必要なローカルストレージのみを使用します。追跡、広告用Cookie、サードパーティ製プロファイルは使用しません。",
    "auth_cookie_accept": "了解しました",
    "sc_explainer_title": "ここでは実際に何が保護されていますか？",
    "sc_explainer_desc": "GaiaShieldは、アカウント、メッセージ、およびネットワークの間の保護層です。コンテンツを判断するのではなく、改ざん、リプレイ攻撃、不正アクセス、不審なログインパターン、危険なゲートウェイ移行などの技術的リスクを判断します。",
    "sc_explainer_identity_desc": "ログインの異常、セッションリスク、他者IDへのアクセスをチェックします。",
    "sc_explainer_messages_desc": "リプレイパターン、改ざんされたエンベロープ、および整合性機能の欠如を検出します。",
    "sc_explainer_network_desc": "信頼性が誤って表示される前に、フェデレーション、レート制限、およびSMTPのリスクをフラグ付けします。",
    "sc_open_security_warnings": "未処理のセキュリティ警告",
    "sc_opt_all": "すべて",
    "sc_opt_low": "低",
    "sc_opt_medium": "中",
    "sc_opt_high": "高",
    "sc_opt_critical": "致命的",
    "sc_opt_failed_login": "ログイン失敗",
    "sc_opt_auth_attack": "認証攻撃",
    "sc_opt_rate_limit": "レート制限",
    "sc_opt_policy_violation": "ポリシー警告",
    "sc_opt_message_replay": "メッセージリプレイ",
    "sc_node_security_data_unavailable": "ノードのセキュリティデータは利用できません",
    "sc_total_events": "総イベント数",
    "sc_login_attacks": "ログイン攻撃数",
    "sc_rate_limits_active": "有効なレート制限数",
    "sc_smtp_shield_hits": "SMTP Shieldヒット数",
    "sc_top_event_categories": "トップイベントカテゴリ",
    "sc_no_entries": "エントリーなし。",
    "sc_node_audit_log": "ノード監査ログ（直近）",
    "sc_no_node_events": "ノードイベントはありません。",
    "archiv": "アーカイブ",
    "entwuerfe": "下書き",
    "markiert": "スター付き",
    "wichtig": "重要",
    "snoozed": "スヌーズ中",
    "papierkorb": "ゴミ箱",
    "spam": "迷惑メール",
    "cancel": "キャンセル",
    "error": "エラー",
    "success": "成功",
    "kopieren": "コピー",
    "block_contact": "連絡先をブロック",
    "unblock_contact": "連絡先のブロック解除",
    "report_contact": "連絡先を報告",
    "check_fingerprint": "指紋を検証",
    "export_encrypted": "エクスポート（暗号化）",
    "export_gaiaproof": "エクスポート（GaiaProof）",
    "export_password_prompt": "チャットのエクスポートを暗号化するためのパスワードを入力してください：",
    "export_success": "チャットが正常に暗号化されてエクスポートされました。",
    "export_failed": "エクスポートに失敗しました：",
    "gaiaproof_export_success": "GaiaProofパッケージが正常にエクスポートされました。",
    "gaiaproof_export_failed": "GaiaProofのエクスポートに失敗しました：",
    "export_gaiaproof_confirm": "すべての署名とサーバー配信レシートが含まれるGaiaProofパッケージをダウンロードしますか？これには少し時間がかかる場合があります。",
    "group_settings_is_private": "プライベートルーム（公開検索不可、参加リクエストのみ）",
    "group_settings_read_only": "読み取り専用モード（所有者と管理者のみがメッセージ送信可能）",
    "group_settings_slow_mode": "スローモード（送信のクールダウン）",
    "gsn_title": "GSNソーシャルフィード",
    "gsn_node_feed": "ノードフィード",
    "gsn_following_feed": "フォロー中",
    "gsn_feed_empty": "投稿が見つかりません。",
    "gsn_composer_placeholder": "フェデレーションの最新情報は何ですか？",
    "gsn_post_btn": "共有",
    "gsn_profile": "ユーザープロフィール",
    "gsn_followers": "フォロワー",
    "gsn_following": "フォロー中",
    "gsn_bio": "説明 / バイオ：",
    "gsn_bio_label": "説明 / バイオ",
    "gsn_display_name": "表示名",
    "gsn_edit_profile": "プロフィールを編集",
    "gsn_save_profile": "保存",
    "gsn_add_image": "画像を追加（暗号化）",
    "gsn_add_emoji": "絵文字を挿入",
    "gsn_avatar_emoji": "アバター（絵文字）",
    "gsn_follow": "フォロー",
    "gsn_unfollow": "フォロー解除",
    "gsn_repost": "共有 / リポスト",
    "gsn_post_created": "投稿が正常に共有されました。",
    "gsn_image_uploaded": "画像が暗号化されてアップロードされました。",
    "gsn_upload_failed": "画像のアップロードに失敗しました：",
    "gsn_comment_placeholder": "コメントを書く...",
    "gsn_delete_confirm_title": "投稿を削除しますか？",
    "gsn_delete_confirm_desc": "この投稿を永久に削除してもよろしいですか？",
    "gsn_delete_comment_confirm_title": "コメントを削除しますか？",
    "gsn_delete_comment_confirm_desc": "このコメントを永久に削除してもよろしいですか？",
    "gsn_report": "報告",
    "gsn_report_title": "違反を報告",
    "gsn_report_category": "カテゴリ",
    "gsn_report_spam": "スパム / 広告",
    "gsn_report_harassment": "嫌がらせ / ヘイトスピーチ",
    "gsn_report_abuse": "悪用",
    "gsn_report_illegal": "违法コンテンツ",
    "gsn_report_severity": "深刻度",
    "gsn_report_low": "低",
    "gsn_report_medium": "中",
    "gsn_report_high": "高",
    "gsn_report_comment": "追加のコメント",
    "gsn_report_submit": "報告",
    "gsn_report_submitted": "報告がガバナンスに送信されました。",
    "gsn_report_post": "投稿を報告",
    "report_group": "グループを報告",
    "report_group_reason_prompt": "보고의 이유를 입력하십시오 (선택):",
    "report_reason_prompt": "보고의 이유를 입력하십시오 (선택):",
    "report_failed": "報告に失敗しました：",
    "report_success": "連絡先が正常に報告されました。",
    "room_read_only_placeholder": "所有者と管理者のみが書き込み可能",
    "read_only_active": "読み取り専用モード",
    "slow_mode_active": "スローモード有効",
    "kommandozentrale": "コマンドセンター",
    "kontakt_blockiert": "連絡先がブロックされました",
    "kontakt_freigegeben": "連絡先のブロックが解除されました",
    "mailbox_settings_title": "メールボックス設定",
    "mailbox_settings_desc": "署名、言語、メールフィルターを管理。",
    "mic_access_denied": "マイクへのアクセスが拒否されました：",
    "no_frequencies_active_desc": "コミュニケーションを開始するには新しいルームを作成してください。",
    "key_changed_warning_title": "セキュリティに関する注意：",
    "key_changed_warning_desc": "この送信者の ID キーが更新されたか、以前に認識されていたキーと異なります。別の安全なチャネルを介して指紋を確認してください。",
    "sc_col_category": "カテゴリ",
    "search_members": "メンバーを検索...",
    "tab_general": "一般",
    "tab_members": "メンバー",
    "tab_requests": "リクエスト",
    "tab_invites": "招待",
    "tab_logs": "ログ",
    "auth_why_gaiacom": "なぜ GaiaCOM？",
    "auth_why_gaiacom_desc": "機密通信のための安全で分散型の代替手段。",
    "auth_self_managed_id": "自己管理型 ID",
    "auth_self_managed_id_desc": "メールアドレスや電話番号を登録することなく、安全な暗号化 ID を即座に作成。",
    "auth_gaiadrop_secure_exchange": "アカウントなしでの安全な交換",
    "auth_gaiadrop_benefit_e2ee": "エンドツーエンドで暗号化",
    "auth_gaiadrop_benefit_no_login": "ログイン不要",
    "auth_gaiadrop_benefit_inbox": "受信者のインボックスに直接配信",
    "auth_terms_of_use": "利用規約",
    "auth_terms_of_use_show": "利用規約を表示",
    "auth_consent_privacy_terms": "プライバシーポリシーと利用規約を読み、これに同意します。",
    "auth_recovery_import_file": "リカバリーファイルをインポート",
    "auth_recovery_password": "リカバリーファイルのパスワード",
    "auth_recovery_local_password": "新しいローカルのロック解除パスワード（最小12文字）",
    "auth_recovery_decrypting": "リカバリーを復号中...",
    "auth_recovery_back": "ログインに戻る",
    "auth_cookie_sovereign": "GaiaCOM は主権を維持します。",
    "auth_cookie_sovereign_desc": "言語、セッション、セキュリティのために技術的に必要なローカルストレージ機能のみを使用します。追跡なし、広告用クッキーなし、サードパーティのプロファイルなし。",
    "auth_cookie_sovereign_accept": "了解",
    "unlock_keyboard_toggle": "⌨️ キーボードを使用",
    "unlock_keypad_toggle": "🔢 PINパッドを使用",
    "unlock_status_denied": "アクセス拒否 / 再試行",
    "unlock_status_decrypting": "保管庫を復号中...",
    "unlock_status_secured": "保管庫は保護 / ロックされています",
    "auth_landing_nav_legal": "法的情報",
    "auth_landing_nav_beta": "ベータテスト",
    "auth_landing_card1_title": "耐量子暗号 (ML-KEM)",
    "auth_landing_card2_title": "100% 分散型",
    "auth_landing_card3_title": "ゼロ知識証明",
    "auth_landing_card4_title": "メタデータ保護",
    "auth_landing_card5_title": "自己管理型ID",
    "auth_landing_hybrid_title": "今日の暗号技術と、明日への備えをひとつに。",
    "auth_landing_hybrid_desc": "GaiaComは、実績のある古典的な鍵交換と耐量子鍵カプセル化を組み合わせます。盲目的な選択ではなく、多層防御を提供します。",
    "auth_landing_x25519_desc": "現在のデバイスと安全なセッションのための、高速で実績のある楕円曲線鍵交換。",
    "auth_landing_mlkem_desc": "「今収集し、後で解読する」脅威シナリオに対抗する、長期的な機密性を備えた耐量子鍵カプセル化。",
    "auth_landing_cycle_title": "サーバーは何も見えません。ネットワークが運ぶのは暗号ノイズだけです。",
    "auth_landing_step1_title": "ローカル暗号化",
    "auth_landing_step1_desc": "メッセージは、ネットワークやサーバーに届く前に、送信者のデバイス上で暗号化されます。",
    "auth_landing_step2_title": "Blobとしての転送",
    "auth_landing_step2_desc": "パッケージは暗号ノイズとして、連合ノードや分散ストレージレイヤーを経由して送信されます。",
    "auth_landing_step3_title": "フェデレーテッドストレージ",
    "auth_landing_step3_desc": "攻撃標的となる中央メールボックスはありません。データは断片化、フェデレーション、または分散され、完全に暗号化されます。",
    "auth_landing_step4_title": "ローカル復号",
    "auth_landing_step4_desc": "受信者のプライベートキーだけが、受信した暗号ノイズを読み取り可能なコンテンツに戻すことができます。",
    "auth_landing_trinity_title": "ひとつのプロトコル概念。三つのインフラレベル。",
    "auth_landing_enterprise_desc": "企業、法律事務所、中規模事業者、産業、プライベートバンキング向け。管理制御、コンプライアンス、サポートを備えたクローズドな通信サークル。",
    "auth_landing_enterprise_list1": "内部主権とユーザー管理",
    "auth_landing_enterprise_list2": "セルフホストノードまたはマネージドソブリンスタック",
    "auth_landing_enterprise_list3": "SLA、サポート、プレミアムモジュール",
    "auth_landing_network_desc": "デジタルプライバシーのためのオープンネットワーク。データ取引はなく、自由で暗号化された通信のためのインフラです。",
    "auth_landing_network_list1": "オープンソースクライアントアプリ",
    "auth_landing_network_list2": "フェデレーテッドノード",
    "auth_landing_network_list3": "中央復号キーを持たない設計",
    "auth_landing_defend_desc": "行政機関、重要インフラ、および隔離された通信チャネル用の、高度にセキュアな特別インフラ。",
    "auth_landing_defend_list1": "ネットワークから完全に隔離された物理的（air-gapped）な導入",
    "auth_landing_defend_list2": "ホワイトラベルでの提供およびソースコード監査",
    "auth_landing_defend_list3": "国家デジタル主権の確立",
    "auth_landing_gov_title": "オープンプロトコル。商業的展開。明確な法的分離。",
    "auth_landing_gov_desc": "GaiaComは、オープンプロトコル、オープンクライアント、および商用プレミアムインフラを分離しています。信頼は透明性から生まれ、収益は企業運営、サポート、統合、専用モジュールから得られます。",
    "auth_landing_price1_desc": "アプリストア配信時のボット防止用のワンタイム手数料。",
    "auth_landing_price2_desc": "自分でビルドしたいユーザー向けの無料オープンソース版。",
    "auth_landing_price3_desc": "中規模事業者、法律事務所、および機密チーム向け。",
    "auth_landing_price4_desc": "企業、高可用性クラスター、LDAP、管理者ルートアクセス向け。",
    "auth_landing_license1_desc": "ユーザー、フォーク、コミュニティ監査のための最大のコード透明性。",
    "auth_landing_license2_desc": "プロトコルの商用閉鎖を防ぐコピーレフト（AGPL/GPL）保護。",
    "auth_landing_license3_desc": "LDAP、ルートアクセス、監査、SLA、および専用ビジネスロジックソリューション。",
    "auth_landing_final_title": "トラストモデルに基づかない通信形式。",
    "auth_landing_final_desc": "GaiaComは単に電子メールを置き換えるだけではありません。耐量子移行が進む現在において、機密通信が依然として読み取り可能なサーバーや40年前の古い前提に基づいている理由を問いかけます。",
    "auth_landing_final_note": "注：このページは、アーキテクチャの構想およびロードマップを説明するものです。セキュリティ上の誓約は、運用の前に監査によって検証される必要があります。"




  };

export default ja;